var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"failure-alert-setting-editor"},[_c('label',{staticClass:"subtitle"},[_vm._v("機器停止通知")]),_c('div',{staticClass:"form-group"},[_c('p',[_vm._v("機器の停止を通知する時間（通信切断または故障 など）")]),_c('p',{staticClass:"value"},[_vm._v("20 分以上")])])])
}]

export { render, staticRenderFns }